import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'
import { useAccountType } from '@/hooks/useAccountType'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

const SimpleBennyContext = createContext(false)

/** Simple Mode owns a Benny surface independently of the dock preference. */
export function BennyAvailabilityProvider({
  children,
}: {
  children: ReactNode
}) {
  const { isPersonal } = useAccountType()
  const { isLoading, checkFeatureFlag } = useFeatureFlags(['SIMPLE_MODE'])
  return (
    <SimpleBennyContext
      value={!isPersonal && !isLoading && checkFeatureFlag('SIMPLE_MODE')}
    >
      {children}
    </SimpleBennyContext>
  )
}

export function useSimpleBennyAvailable() {
  return useContext(SimpleBennyContext)
}
